module.exports = "//public.getcloudapp.com/packs/media/images/video-trim-active-d0b78b4d03c32ef7bbd5f59ec62c0fde.svg";